export interface IError {
  message: string
  code?: string
}

export const isIError = (arg: any): arg is IError =>
  arg && ((arg as IError).message !== undefined || arg.__typename === 'Error')
